import React from "react";
import { Grid, Icon, FormHelperText } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CreatePlantModal from "modules/plants/CreatePlantModal";
import { useFieldArray, useFormContext } from "react-hook-form";
import { OrganizationProductType } from "generated/graphql";
import PlantProductField from "./PlantProductField";

interface PlantProductsFieldsProps {
  action: "create" | "update";
  productType: OrganizationProductType;
}

export default function PlantProductsFields({ action, productType }: PlantProductsFieldsProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const inputKey = action === "create" ? "connect" : "sync";

  const plantProducts = useFieldArray({
    control,
    name: `plantProducts.${inputKey}` as const,
    keyName: "key",
  });

  return (
    <Grid item xs={12}>
      <MDBox display="flex" alignItems="center" justifyContent="space-between">
        <MDTypography variant="h6">Materials</MDTypography>
        <MDBox display="flex" alignItems="center" gap={2}>
          <MDButton
            size="small"
            type="button"
            variant="contained"
            color="blue"
            onClick={() => {
              plantProducts.append({ plantId: null, id: null });
            }}
          >
            Add Material
          </MDButton>
          <CreatePlantModal size="small" variant="contained" />
        </MDBox>
      </MDBox>
      {plantProducts.fields.length > 0 &&
        plantProducts.fields.map((field, index) => (
          <PlantProductField
            key={field.key}
            index={index}
            inputKey={inputKey}
            productType={productType}
            onRemove={() => plantProducts.remove(index)}
          />
        ))}
      {errors.plantProducts && (
        <FormHelperText error sx={{ marginLeft: "0px", marginTop: "8px" }}>
          {errors.plantProducts.message || errors.plantProducts[inputKey]?.message}
        </FormHelperText>
      )}
    </Grid>
  );
}
